module.exports = __webpack_public_path__ + "static/media/DejaVuSerif-Bold.25670b4a.ttf";